import { type FC, useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box } from '@dhl-ui/components'
import { CurrentCartIcon } from '@dhl/c2c'
import { links } from '~/links.js'
// FIXME: these are generics when shared accross view
import { ProfileAvatar } from '../Avatar/index.js'
import { SearchControl } from '~/search/view/components/search-control/SearchControl.js'

export const HeaderContent: FC = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleProfileClick = useCallback(
    () =>
      navigate(links.profileOverviewLink(), {
        state: { initialReferrer: location.pathname },
      }),
    [location.pathname, navigate]
  )

  const handleGoToC2C = () => navigate(links.c2cBasketLink(), { state: { referrer: location.pathname } })

  return (
    <Box sx={{ display: 'flex', gap: { xs: 1, md: 2 }, alignItems: 'center' }}>
      <SearchControl />
      <Box mr={1.5}>
        <CurrentCartIcon onClick={handleGoToC2C} />
      </Box>
      <ProfileAvatar onClick={handleProfileClick} data-test="profile-menu-button" />
    </Box>
  )
}
